(() => {
  const prodHandle = location.pathname.split("/").pop();

  function createBanner(img, title, desc, extra = "", freeTag = "PAYDAY SALE") {
    const wrapper = document.createElement("div");
    wrapper.className = "free_gift_banner layout2";

    wrapper.innerHTML = `
      <div class="free-gift">
      <img src="${img}" alt="">
      <div class="info-wrapper">
          <div class="title-wrapper">
          <span class="free-tag">${freeTag}</span>
          <span class="title">${title}</span>
          </div>
          ${desc ? `<p class="description">${desc}</p>` : ""}
          <span class="description red">${extra}</span>
      </div>
      </div>
  `;

    return wrapper;
  }

  let banner = null;

  if (prodHandle == "prism-vortex") {
    banner = createBanner(
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Vortex_6b603a64-8867-4da8-85ae-5b49c6946f9b.png?v=1787287381",
      "Limited Time Price Drop",
      "Only for Vortex & Vortex Pro Air Purifier",
      "Offer End 25 August",
    );
  }
  if (prodHandle == "prism-vortex-pro") {
    banner = createBanner(
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Vortex_Pro.png?v=1787287382",
      "Limited Time Price Drop",
      "Only for Vortex & Vortex Pro Air Purifier",
      "Offer End 25 August",
    );
  }

  if (banner) {
    const target =
      document.querySelector('[itemprop="offers"]') ||
      document.querySelector(".variant-selector") ||
      document.querySelector(".product-form");

    if (!target) return;

    target.parentNode.insertBefore(banner, target);
  }
})()
